var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.3H3.8M5.2 10.1H3.8M9.4 4.5H3.8M12.2 4.36V11.64C12.2 12.8161 12.2 13.4042 11.9711 13.8534C11.7698 14.2485 11.4485 14.5698 11.0534 14.7711C10.6042 15 10.0161 15 8.84 15H4.36C3.18389 15 2.59583 15 2.14662 14.7711C1.75148 14.5698 1.43022 14.2485 1.22889 13.8534C1 13.4042 1 12.8161 1 11.64V4.36C1 3.18389 1 2.59583 1.22889 2.14662C1.43022 1.75148 1.75148 1.43022 2.14662 1.22889C2.59583 1 3.18389 1 4.36 1H8.84C10.0161 1 10.6042 1 11.0534 1.22889C11.4485 1.43022 11.7698 1.75148 11.9711 2.14662C12.2 2.59583 12.2 3.18389 12.2 4.36Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note_icon.90f1e95a570f75bb6ccf474167eaebc1.svg";
export { ForwardRef as ReactComponent };